export default __webpack_public_path__ + "6058d3da655fb35169c21cf19a0e6170.ttf";